import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect } from 'react';
import MetaTags from 'react-meta-tags';
import Paginator from 'react-hooks-paginator';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { connect } from 'react-redux';
import { getSortedProducts } from '../../helpers/product';
import LayoutOne from '../../layouts/LayoutOne';
import Breadcrumb from '../../wrappers/breadcrumb/Breadcrumb';
import ShopSidebar from '../../wrappers/product/ShopSidebar';
import ShopTopbar from '../../wrappers/product/ShopTopbar';
import ShopProducts from '../../wrappers/product/ShopProducts';
import { Categories, getAllProducts } from "../../Services/API/Get";
import LoadingSpinner from "../../components/LoadingSpinner/loadingSpinner";
import _ from "lodash"

const ShopGridStandard = ({ location, products }) => {
  var matches = window.matchMedia("(max-width: 425px)");
  const [layout, setLayout] = useState('grid three-column');
  const [sortType, setSortType] = useState('');
  const [sortValue, setSortValue] = useState('');
  const [filterSortType, setFilterSortType] = useState('');
  const [filterSortValue, setFilterSortValue] = useState('');
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentData, setCurrentData] = useState([]);
  const [sortedProducts, setSortedProducts] = useState([]);

  const [nProducts, setnProducts] = useState([]);
  const [allSizes, setallSizes] = useState([]);
  const [categories, setcategories] = useState([]);
  const [tags, settags] = useState([]);
  const [selectedSize, setselectedSize] = useState("");
  const [selectedCat, setselectedCat] = useState("");
  const [count, setcount] = useState(1);
  const [search, setsearch] = useState("");
  const [lopen, setlopen] = useState(false);

  const pageLimit = 15;
  const { pathname } = location;

  const getLayout = (layout) => {
    setLayout(layout)
  }

  const getSortParams = (sortType, sortValue) => {
    if (sortType === "size") {
      setselectedSize(sortValue);
    }
    if (sortType === "category") {
      setselectedCat(sortValue);
    }
    setSortType(sortType);
    setSortValue(sortValue);
  }

  const getFilterSortParams = (sortType, sortValue) => {
    setFilterSortType(sortType);
    setFilterSortValue(sortValue);
  }

  useEffect(() => {
    let sortedProducts = getSortedProducts(products, sortType, sortValue);
    const filterSortedProducts = getSortedProducts(sortedProducts, filterSortType, filterSortValue);
    sortedProducts = filterSortedProducts;
    setSortedProducts(sortedProducts);
    setCurrentData(sortedProducts.slice(offset, offset + pageLimit));
  }, [offset, products, sortType, sortValue, filterSortType, filterSortValue]);

  useEffect(() => {

    // getFilters();
    getallCategory();

    const filterButtons = document.querySelectorAll(
      ".sidebar-widget-list-left button"
    );
    const filterButtons2 = document.querySelectorAll(
      ".sidebar-widget-list-left2 button"
    );

    filterButtons.forEach(item => {
      item.classList.remove("active");
    });


    filterButtons[0].classList.add("active");

  }, []);

  useEffect(() => {
    // setlopen(true);
    // if (allSizes.length !== 0) {
    getItemProducts();
    // }


  }, [offset, products, sortType, sortValue, filterSortType, filterSortValue, allSizes, search]);

  const getallCategory = () => {

    Categories()
      .then((response) => {
        console.log("category>>>>", response?.data);
        setcategories(response.data);
        // this.setState(
        //   {
        //     array: res.data.result,
        //     filter: res.data.result,
        //     showPages: m,
        //     showOff: true,
        //   },
        //   async () => {
        //     await this.getPaginationGroup(m);
        //   }
        // );
      })
      .catch(() => {
        // this.setState({
        //   array: [],
        //   filter: [],
        //   showPages: 1,
        //   showOff: false,
        // });
      });

  }

  const getFilters = () => {

    const ob = {
      sort: {
        sortField: "displayName",
        sort: "asc",
      },
      distinct: 0,

    };

    getAllProducts(ob).then((res) => {
      const allColors = _.uniqBy(res?.data?.result, function (e) {
        return e.clolour;
      });
      const allSizes = _.uniqBy(res?.data?.result, function (e) {
        return e.size;
      });
      var sizeArr = allSizes?.filter(function (el) {
        return el.size !== "";
      });
      const allPrice = _.uniqBy(res?.data?.result, function (e) {
        return e.discountedprice;
      });
      const allTags = _.uniqBy(res?.data?.result, function (e) {
        return e.tags;
      });
      const myPrices = _.map(allPrice, "discountedprice");

      const Pricelist = _.sortBy(myPrices, [
        function (o) {
          return o;
        },
      ]);

      const mySizes = _.map(sizeArr, "size");
      const myColors = _.map(allColors, "clolour");
      const myTags = _.map(allTags, "tags");

      const updateMyColors = myColors?.map((item, index) => {
        return {
          id: index,
          name: item,
          status: false,
        };
      });
      console.log("sizes<> tags", mySizes, myTags)
      setallSizes(mySizes);
      settags(myTags);
      // this.setState({
      //   color: updateMyColors,
      //   size: mySizes,
      //   min: Pricelist[0],
      //   max: Pricelist[Pricelist.length - 1],
      //   range: {
      //     min: Pricelist[0],
      //     max: Pricelist[Pricelist.length - 1],
      //   },
      // });
    });



  }

  const getItemProducts = () => {
    let sort = ""

    if (filterSortValue === "priceHighToLow") {

      sort = {


        sortField: "productName",
        sort: "desc",

      }
    } else if (filterSortValue === "priceLowToHigh") {

      sort = {


        sortField: "productName",
        sort: "asc",

      }
    } else {
      sort = {


        sortField: "displayName",
        sort: "asc",

      }
    }





    console.log(sortType)

    const obj = {

      sort: sort,
      pNo: currentPage,
      limit: pageLimit,
      size: selectedSize,
      categories: selectedCat === "" ? JSON.stringify([]) : JSON.stringify([selectedCat]),
      search: search,

    };
    console.log("><<<<<<<<<<<<", obj);
    try {
      getAllProducts(obj)
        .then((response) => {
          // setlopen(false);
          console.log(">>>>>>>>>>>>>>>>>>", response?.data);

          let m =
            Math.ceil(parseFloat(response.data.count[0].pages)) === 0
              ? 1
              : Math.ceil(parseFloat(response.data.count[0].pages));

          setnProducts(response.data.result);
          setcount(response.data.count[0].count);
          // this.setState(
          //   {
          //     array: res.data.result,
          //     filter: res.data.result,
          //     showPages: m,
          //     showOff: true,
          //   },
          //   async () => {
          //     await this.getPaginationGroup(m);
          //   }
          // );
        })
        .catch(() => {
          setnProducts([]);
          setcount(1);
          // setlopen(false);
          // this.setState({
          //   array: [],
          //   filter: [],
          //   showPages: 1,
          //   showOff: false,
          // });
        });
    } catch (error) {
      console.log("T&C ", error);
    }
  }

  return (
    <Fragment>
      <LoadingSpinner open={lopen} />
      <MetaTags>
        <title>OZ Rentals | Shop Page</title>
        <meta name="description" content="Shop page of flone react minimalist eCommerce template." />
      </MetaTags>

      <BreadcrumbsItem to={process.env.PUBLIC_URL + '/'}>Home</BreadcrumbsItem>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + pathname}>Shop</BreadcrumbsItem>

      <LayoutOne headerTop="visible">
        {/* breadcrumb */}
        <Breadcrumb />

        <div className="shop-area pt-95 pb-100">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 order-1 order-lg-1">
                {/* shop sidebar */}
                <ShopSidebar setSearch={setsearch} products={products} getSortParams={getSortParams} pSizes={allSizes} pTags={tags} pCat={categories} sideSpaceClass="mr-30" />
              </div>
             
              <div className="col-lg-9 order-1 order-lg-2">
                {/* shop topbar default */}
                <ShopTopbar getLayout={getLayout} getFilterSortParams={getFilterSortParams} productCount={count} sortedProductCount={nProducts.length + ((currentPage - 1) * pageLimit)} />

                {/* shop page content default */}
                <ShopProducts layout={layout} products={nProducts} />

                {/* shop product pagination */}
                <div className="pro-pagination-style text-center mt-30">
                  <Paginator
                    totalRecords={count}
                    pageLimit={pageLimit}
                    pageNeighbours={2}
                    setOffset={setOffset}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    pageContainerClass="mb-0 mt-0"
                    pagePrevText="«"
                    pageNextText="»"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  )
}

ShopGridStandard.propTypes = {
  location: PropTypes.object,
  products: PropTypes.array
}

const mapStateToProps = state => {
  return {
    products: state.productData.products
  }
}

export default connect(mapStateToProps)(ShopGridStandard);